import { Box, Dialog, DialogContent, Grid, Slide } from "@mui/material";
import { useSnackbar } from "notistack";
import React, { useContext, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { GlobalContext } from "../Contexts/GlobalContext";
import { UserContext } from "../Contexts/UserContext";
import successGif from "../assets/successGif.gif";
import { verifyOtp2 } from "../api/agent";
import { l } from "../util/languageConvertor";
import useFindUser from "../hooks/AuthScreens/Agent/useFindUser";
import useAuth from "../hooks/AuthScreens/Agent/useAuth";
// import { verifyLogin } from "../api/agent";

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const OtpLogin = ({ open, handleClose }) => {
  // let interval;
  const { otpState, resetState, showRewardState, langState, tokenState } =
    useContext(GlobalContext);
  const { setUser, signUpDataState } = useContext(UserContext);
  const [tokenData, setTokenData] = tokenState;
  const { handleEnvironment } = useFindUser();

  const [vId, setVid] = useState("");
  const [isOver, setOver] = useState(false);
  const [showResend, setShowResend] = useState(false);
  const [lang, setLang] = langState;
  const [intervalId, setIntervalId] = useState(null);

  const navigate = useNavigate();
  const { loginUser } = useAuth();

  const [otpData, setOtpData] = otpState;
  const [isResetVerified, setResetVerified] = resetState;
  const [isVerified, setVerified] = useState(false);

  let inputs = [];

  const [otp, setOtp] = useState("");
  const [isLoading, setLoading] = useState(false);
  const [timer, setTimer] = useState("05:00");
  const { enqueueSnackbar } = useSnackbar();

  const input1 = useRef(null);
  const input2 = useRef(null);
  const input3 = useRef(null);
  const input4 = useRef(null);
  const timerRef = useRef(null);
  const verification = useRef(null);

  useEffect(() => {
    if (!open) {
      clearInterval(intervalId);
      setIntervalId(null);
    } else {
      startTimer(5 * 60);
    }
  }, []);

  useEffect(() => {
    setVid(otpData.vId);
  }, [otpData]);

  const handleInput = (target) => {
    if (/^\d+$/.test(target.value)) {
      getOTP();
      let nextInput = target.nextElementSibling;

      if (nextInput && target.value) {
        nextInput.focus();
        nextInput.value && nextInput.select();
      }
    } else {
      target.value = "";
    }
  };

  const handleBackspace = (target) => {
    getOTP();
    return target.value
      ? (target.value = "")
      : target.previousElementSibling?.focus();
  };

  const handleArrowLeft = (target) => {
    const previousInput = target.previousElementSibling;
    return !previousInput ? undefined : previousInput.focus();
  };
  const handleArrowRight = (target) => {
    const nextInput = target.nextElementSibling;
    return !nextInput ? undefined : nextInput.focus();
  };

  const handlePaste = (event) => {
    let pasteText = (event.clipboardData || window.clipboardData).getData(
      "text"
    );

    const inputs = [
      input1.current,
      input2.current,
      input3.current,
      input4.current,
    ];

    inputs.forEach((input, index) => {
      input.value = pasteText[index] || ``;
      if (pasteText[index]) {
        input?.focus();
      }
    });
    getOTP();
    event.preventDefault();
  };

  useEffect(() => {
    autoFetch();
  }, []);

  const autoFetch = async () => {
    const signal = new AbortController();
    setTimeout(() => {
      signal.abort();
    }, 1 * 60 * 1000);

    if ("OTPCredential" in window) {
      try {
        if (navigator.credentials) {
          try {
            await navigator.credentials
              .get({ abort: signal, otp: { transport: ["sms"] } })
              .then((content) => {
                if (content && content.code) {
                  input1.current.value = content.code[0];
                  input2.current.value = content.code[1];
                  input3.current.value = content.code[2];
                  input4.current.value = content.code[3];

                  setOtp(content.code);
                }
              })
              .catch((e) => console.log(e));
          } catch (e) {
            return;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    // if ("OTPCredential" in window) {
    //   const ac = new AbortController();

    //   navigator.credentials
    //     .get({
    //       otp: { transport: ["sms"] },
    //       signal: ac.signal,
    //     })
    //     .then((otp) => {
    //       alert(otp);

    //       if (otp.length === 4) {
    //         input1.current.value = otp[0];
    //         input2.current.value = otp[1];
    //         input3.current.value = otp[2];
    //         input4.current.value = otp[3];

    //         setOtp(otp);
    //       }
    //       ac.abort();
    //     })
    //     .catch((err) => {
    //       // alert("Some error")
    //       ac.abort();
    //     });
    // }
  };

  const getOTP = () => {
    const inputs = [
      input1.current.value,
      input2.current.value,
      input3.current.value,
      input4.current.value,
    ];
    let temp = inputs[0] + inputs[1] + inputs[2] + inputs[3];
    setOtp(temp);
  };

  useEffect(() => {
    if (validateOtp()) {
      submitOTP();
    }
  }, [otp]);

  const validateOtp = () => {
    if (otp.length === 4 && /^\d+$/.test(otp)) {
      return true;
    }
    return false;
  };

  const requestOTP = async () => {
    try {
      await loginUser(otpData.mobile);
    } catch (error) {
      enqueueSnackbar(error.response.data.errors[0].message, {
        variant: "error",
      });
    }
  };

  const submitOTP = async () => {
    setLoading(true);
    try {
      let payload = {
        otp,
        verificationId: vId,
        fcm_token: tokenData?.token,
        device_info: {
          info: window?.navigator?.userAgent || "",
        },
      };

      let { data: response } = await verifyOtp2(payload);
      setVerified(true);
      setTimeout(() => {
        setUser({
          ...response?.data,
          name: response?.data?.name || "User",
          language: response?.data?.language || "hindi",
        });

        handleEnvironment({
          ...response?.data,
          name: response?.data?.name || "User",
          language: response?.data?.language || "hindi",
        });

        if (
          !["english", "hindi", "hinglish"].includes(response?.data?.language)
        ) {
          navigate("/language-selection");
          setLang("hindi");
        } else {
          navigate(`/home`);
          setLang(response?.data?.language);
        }
      }, 2000);
    } catch (error) {
      enqueueSnackbar(error?.response?.data?.message || "Error", {
        variant: "error",
      });
      setOtp("");
      input1.current.value = "";
      input2.current.value = "";
      input3.current.value = "";
      input4.current.value = "";
      if (!(error?.response?.data?.message || "")?.includes("Invalid OTP")) {
        handleClose();
      }
    }
    setLoading(false);
  };

  const handleResend = async () => {
    setTimer("05:00");
    clearInterval(intervalId);
    setIntervalId(null);
    startTimer(5 * 60);
    setOver(false);
    setShowResend(false);
    setOtp("");
    input1.current.value = "";
    input2.current.value = "";
    input3.current.value = "";
    input4.current.value = "";
    await requestOTP();
    enqueueSnackbar(l("OTP resent successfully", lang), { variant: "success" });
  };

  function startTimer(duration, display) {
    var timer = duration,
      minutes,
      seconds;

    setIntervalId(
      setInterval(function () {
        minutes = parseInt(timer / 60, 10);
        seconds = parseInt(timer % 60, 10);

        minutes = minutes < 10 ? "0" + minutes : minutes;
        seconds = seconds < 10 ? "0" + seconds : seconds;

        setTimer(minutes + ":" + seconds);

        if (Number(minutes) < 4) {
          setShowResend(true);
        }

        if (--timer === 0 || timer < 0) {
          clearInterval(intervalId);
          setIntervalId(null);
          setTimer("00:00");
          setOver(true);
        }
      }, 1000)
    );
  }

  const handleInputSingle = (e, element) => {
    if (e.target.value !== "") return false;
    switch (e.key.toString().toLowerCase()) {
      case "backspace":
        return handleBackspace(e.target);
      case "arrowleft":
        return handleArrowLeft(e.target);
      case "arrowright":
        return handleArrowRight(e.target);
    }
  };

  useEffect(() => {
    return () => {
      clearInterval(intervalId);
    };
  }, [intervalId]);

  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleClose}
      aria-describedby="alert-dialog-slide-description"
      PaperProps={{
        style: { borderRadius: 20 },
      }}
    >
      {isLoading && (
        <div className="strip w-100" style={{ position: "absolute", top: 0 }}>
          &nbsp;
        </div>
      )}
      <DialogContent>
        {!isVerified && (
          <div className="verification-wrapper mt-0">
            <Grid container spacing={2} className="pb-2">
              <Grid item xs={12} sm={12}>
                <Box className="form-box">
                  <p className="mb-5 otp-text">
                    {l("An otp is sent your Mobile Number", lang)}
                    <b> {otpData?.mobile}</b>
                  </p>
                  <form class="verification w-100" ref={verification}>
                    <input
                      ref={input1}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--1"
                      id="verification-input-1"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[0])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                      autoFocus
                    />
                    <input
                      ref={input2}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--2"
                      id="verification-input-2"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[1])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                    <input
                      ref={input3}
                      type="number"
                      autoComplete="off"
                      class="verification__input  verification__input--3"
                      id="verification-input-3"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[2])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                    <input
                      ref={input4}
                      type="number"
                      class="verification__input  verification__input--4"
                      id="verification-input-4"
                      autoComplete="off"
                      placeholder="-"
                      maxLength="1"
                      inputMode="numeric"
                      onKeyDown={(e) => handleInputSingle(e, inputs[3])}
                      onInput={(e) => handleInput(e.target)}
                      onPaste={(e) => handlePaste(e)}
                      disabled={isLoading}
                    />
                  </form>
                  <div className="verification_footer">
                    <p className="info">
                      {l("This Session will End in", lang)} {timer}.
                      <br />
                      {showResend && (
                        <>
                          Didn’t receive a code?{" "}
                          <span
                            className="pointer"
                            style={{ fontWeight: "500", color: "blue" }}
                            onClick={() => {
                              handleResend();
                            }}
                          >
                            Resend Code
                          </span>
                        </>
                      )}
                    </p>
                  </div>
                </Box>
              </Grid>
            </Grid>
          </div>
        )}

        {isVerified && (
          <div className="verification-div">
            <img src={successGif} width={"100%"} />
            <p className="text-center verified-text">Otp verified</p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default OtpLogin;
